// src/pages/ContactUs.tsx
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import {
  InnerCard,
  InnerContainer,
  InnerSection,
  Paragraph,
  TextLink,
} from '../components/InnerPageLayout';
import JsonData from '../data/data.json';
import { SiteData } from '../types/siteDataTypes';
import ProductHeader from '../components/ProductHeader';

const ContactCard = styled(InnerCard)`
  text-align: center;
  display: grid;
  gap: 12px;
`;

const ContactParagraph = styled(Paragraph)`
  font-size: 18px;
`;

const ContactUs: React.FC = () => {
  const [siteData, setSiteData] = useState<SiteData | null>(null);

  useEffect(() => {
    setSiteData(JsonData as SiteData);
  }, []);

  return (
    <>
      {siteData ? (
        <>
          <ProductHeader data={{ title: 'Contact Us', paragraph: '' }} />
          <InnerSection>
            <InnerContainer>
              <ContactCard>
                {/* <PageTitle>Contact Us</PageTitle> */}
                <ContactParagraph>
                  You can contact us at{' '}
                  <TextLink href={`mailto:${siteData.AppsData.customerSupportEmail}`}>
                    {siteData.AppsData.customerSupportEmail}
                  </TextLink>
                  .
                </ContactParagraph>
              </ContactCard>
            </InnerContainer>
          </InnerSection>
          <Footer />
        </>
      ) : (
        <p>Loading...</p>
      )}
    </>
  );
};

export default ContactUs;
